import { type Courses } from "@common/components/Courses/types";
import { type RadioOptionItem } from "@common/controls/Inputs/Radio";
import { useI18n } from "@common/hooks/i18n";
import { i18nFormat } from "@common/lib/i18n";
import React from "react";
import { Question } from "./Question";

type Props = Courses.QuizReview & {
  end: () => void;
};
export default (props: Props) => {
  const i18n = useI18n();

  const [index, setIndex] = React.useState(0);

  const isLast = React.useMemo(() => props.questions.length - 1 === index, [index, props.questions]);
  const question = React.useMemo(() => props.questions[index], [index, props.questions]);
  const isMultipleAnswers = React.useMemo(() => question.answers.filter((x) => x.isCorrect).length > 1, [question]);

  const options = React.useMemo(
    (): RadioOptionItem[] =>
      question.answers
        .sort((a, b) => a.answer.localeCompare(b.answer))
        .map((x) => ({
          className: x.isCorrect ? "correct" : question.userAnswerIds.includes(x.id) ? "wrong" : "",
          label: x.answer,
          value: x.id
        })),
    [question]
  );

  const answer = React.useCallback(() => {
    if (isLast) {
      props.end();
    } else {
      setIndex(index + 1);
    }
  }, [index, isLast, props.end]);

  const back = React.useCallback(() => setIndex(index - 1), [index]);

  return (
    <div className="quiz review">
      <p className="header">{i18nFormat(i18n.questionMOfN, ["M", index + 1], ["N", props.questions.length])}</p>

      <Question
        answer={answer}
        answerIds={question.userAnswerIds}
        answerOptions={options}
        back={index > 0 ? back : undefined}
        isBusy={false}
        isLast={isLast}
        isMultipleAnswers={isMultipleAnswers}
        isReadonly
        question={question.question}
      />
    </div>
  );
};
